import Api from '@sendsprint/api-types';
import FormField from '@sendsprint/ui-react/dist/components/Form/formInput';
import FormFieldWithExternalLabel from '@src/components/form/FormFieldWithExternalLabel';
import { useAccount } from '@src/contexts';
import React from 'react';

const TargetCurrencyField = () => {
  const { userAddress } = useAccount();
  return (
    <FormFieldWithExternalLabel label="Currency">
      <FormField
        name="targetCurrency"
        label="Currency"
        disabled
        extraInfo="This is gotten from your primary settlement account"
        icon={userAddress?.country as Api.Model.CountryInitials}
      />
    </FormFieldWithExternalLabel>
  );
};

export default TargetCurrencyField;
